import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\",\"weight\":[\"400\",\"600\",\"700\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/sqxbonds-UI/apps/src/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/BootstrapClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/common/AnalyticsClientEffect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NProgressBar"] */ "/var/www/sqxbonds-UI/apps/src/components/NProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/var/www/sqxbonds-UI/apps/src/providers/ReduxProvider.tsx");
